import IMask, { MaskedRange } from 'imask';

export const buildMaskedDateOptions = (toYear?: Date|number) => {
	if (typeof(toYear) === 'undefined') {
		toYear = new Date().getFullYear();
	}
	return {
		mask: Date,
		pattern: 'Y-`m-`d',
		blocks: {
			d: {
				mask: MaskedRange,
				from: 1,
				to: 31,
				maxLength: 2,
			},
			m: {
				mask: MaskedRange,
				from: 1,
				to: 12,
				maxLength: 2,
			},
			Y: {
				mask: MaskedRange,
				from: 1900,
				to: toYear
			},
		},
		format: (date: Date) => {
			const day = date.getDate().toString().padStart(2, '0');
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const year = date.getFullYear().toString();

			return `${year}-${month}-${day}`;
		},
		parse: (str: string) => {
			const [year, month, day] = str.split('-').map(Number);
			return new Date(year, month - 1, day);
		},
		overwrite: true,
	}
};
